export default __webpack_public_path__ + "public/images/errors/not-found.png?e8dd1dc2";